import React from 'react';

import './audioplayer.css';

export default class AudioPlayer extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			pause: true,
			mute: false,
			position: "00:00",
			duration: '00:00',
			percent: 0,
		};
		this.play = this.play.bind(this);
		this.position = this.position.bind(this);
		this.mute = this.mute.bind(this);
	}

	async componentDidMount() {
		//this.getDuration();
		let audio = await document.getElementById("audioplayer");
		audio.onloadstart=(data) => {
			//this.setState({enabled: true});
		};
		audio.ontimeupdate=async (data) => {
			let currentTime = await this.convertTime(data.target.currentTime);
			if( currentTime !== this.state.position ) {
				this.setState({position: currentTime, percent: Math.floor(data.target.currentTime / data.target.duration * 100)});
			}
		}
		audio.onloadedmetadata = async (data)=>{
			let duration = await this.convertTime(data.target.duration);
			if( duration !== this.state.duration ) this.setState({duration});
		}
	}

	async convertTime(time) {
		let duration = Math.ceil(time);
		let mins = ~~((duration) / 60);
		let secs = ~~duration % 60;
		return `${mins.toString().padStart(2,"0")}:${secs.toString().padStart(2,"0")}`;
	}

	/*async getCurrentTime(data) {
		
	}

	async getDuration(tries = 0) {
		let audio = document.getElementById("audioplayer");
		audio.onloadstart = (x) => {
			//this.setState({enabled: true});
			
		};
		
		if( audio.duration ) {
			let duration = Math.ceil(audio.duration);
			let mins = ~~((duration % 3600) / 60);
			let secs = ~~duration % 60;
			
			this.setState({duration: `${mins}:${secs}`});
		}
		if( !audio.duration && tries < 10 ) {
			
			setTimeout(()=>{
				this.getDuration(tries + 1);
			}, 1000);
		}
	}*/

	async play() {
		try {
			let audio = document.getElementById("audioplayer");
			
			if( audio.paused ) {
				audio.play();
				this.setState({pause: false});
			} else {
				audio.pause();
				this.setState({pause: true});
			}
		} catch(error) {

		}
	}

	async position(event) {
		try {
			let percent = (event.clientX - event.target.getBoundingClientRect().left) / event.target.getBoundingClientRect().width;
			let audio = document.getElementById("audioplayer");
			let time = Math.floor(percent*audio.duration);
			audio.currentTime = time;
		} catch(error) {

		}
	}

	async mute() {
		try {
			let audio = document.getElementById("audioplayer");
			
			if( audio.volume === 0 ) {
				audio.volume = 1;
				this.setState({mute: false});
			} else {
				audio.volume = 0;
				this.setState({mute: true});
			}
		} catch(error) {
			
		}
	}


	render() {
		return (
			<div className={`audioplayer ${this.state.pause===false&&'audioplayer-playing'} ${this.state.mute===true&&'audioplayer-mute'}`}>
				<audio id="audioplayer" preload="metadata" controls={false} autoPlay={false} /*onTimeUpdate={(e)=>this.getCurrentTime(e)}*/ style={{width: 0, height: 0, visibility: 'hidden'}} crossOrigin="use-credentials">
					<source src={this.props.src} crossOrigin="use-credentials" />
				</audio>
				<div className="audioplayer-playpause" title="Pause" onClick={()=>this.play()}>
					<span>Pause</span>
				</div>
				<div className="audioplayer-time audioplayer-time-current">{this.state.position}</div>
				<div className="audioplayer-bar">
					<div className="audioplayer-bar-loaded" style={{width: '100%'}}></div>
					<div className="audioplayer-bar-played" style={{width: `${this.state.percent}%`}}></div>
					<div className="audioplayer-bar-overlay" onClick={(e)=>this.position(e)} style={{width: '100%', zIndex: 100}}></div>
				</div>
				<div className="audioplayer-time audioplayer-time-duration">{this.state.duration}</div>
				<div className="audioplayer-volume">
					<div className="audioplayer-volume-button" title="Volume" onClick={()=>this.mute()}><span>Volume</span></div>
					{/*<div className="audioplayer-volume-adjust">
						<div>
							<div style={{height: '100%'}}></div>
						</div>
					</div>*/}
				</div>
			</div>
		)
	}

}


